import styled from "styled-components";

export const ModalButton = styled.span`
  padding: 6px 10px;
  cursor pointer;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  margin-right: 10px;
`;
